import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import './cta1.css'; // Import the updated custom CSS

const CTA1 = ({
  action1="Reach out now!",
  content1="At RoboMec Automation, we provide comprehensive industrial automation solutions.",
  heading1="Discover Our Cutting-Edge Machinery Solutions",
}) => {
  return (
    <div className="py-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={10}>
            <div className="cta1-card-wrapper">
              <Card className="cta1-card shadow-lg">
              <Card.Body
                  className="p-5 cta1-card-body"
                >
                  <Row className="align-items-center">
                    <Col md={8}>
                      <h2
                        className="mb-4 fw-bold"
                      >
                        {heading1}
                      </h2>
                      <p
                        className="lead"
                      >
                        {content1}
                      </p>
                    </Col>
                    <Col md={4} className="text-end">
                      {/* Use Link for navigation */}
                      <Link to="/contact-us">
                        <button
                          className="btn btn-light btn-lg fw-bold cta1-button"
                          type="button"
                        >
                          {action1}
                        </button>
                      </Link>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

CTA1.propTypes = {
  heading1: PropTypes.string,
  content1: PropTypes.string,
  action1: PropTypes.string,
};

export default CTA1;
